import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
import { getTermsAndConditions } from './services/UserService'
Vue.use(Router)

export const routes = {
  home: 'home',
  howItWorks: 'howItWorks',
  content: 'content',
  impact: 'impact',
  feed: 'feed',
  feedCarousel: 'feedCarousel',
  feedInitial: 'feedInitial',
  search: 'search',
  resource: 'resource',
  resourcePresentation: 'resourcePresentation',
  teacherResource: 'teacherResource',
  teacherResourceTrigger: 'teacherResourceTrigger',
  teacherResourceClass: 'teacherResourceClass',
  teacherResourceValuation: 'teacherResourceValuation',
  studentResource: 'studentResource',
  studentResourceTrigger: 'studentResourceTrigger',
  studentResourceClass: 'studentResourceClass',
  studentPublicResource: 'studentPublicResource',
  studentPublicResourceClass: 'studentPublicResourceClass',
  studentPublicResourceTrigger: 'studentPublicResourceTrigger',
  stats: 'stats',
  folderList: 'folderList',
  folderContent: 'folderContent',
  educationalPrograms: 'educationalPrograms',
  educationalProgram: 'educationalProgram',
  resetPassword: 'resetPassword',
  profile: 'profile',
  myProfile: 'myProfile',
  myProfileEdit: 'myProfileEdit',
  school: 'school',
  schoolEdit: 'schoolEdit',
  schoolGroup: 'schoolGroup',
  schoolGroupEdit: 'schoolGroupEdit',
  trial: 'trial',
  register: 'register',
  notFound: 'notFound',
  faqs: 'faqs',
  trialFinished: 'trialFinished',
  quote: 'quote',
  usedToken: 'usedToken',
  expiredToken: 'expiredToken',
  activate: 'activate',
  license: 'license',
  signTerms: 'signTerms',
  krea: 'krea',
  kreaMyResources: 'kreaMyResources',
  kreaSchoolsGroupResources: 'kreaSchoolsGroupResources',
  kimpleFolderContent: 'kimpleFolderContent',
  kreaResource: 'kreaResource',
  kreaResourcePresentation: 'kreaResourcePresentation',
  kreaResourceTeacher: 'kreaResourceTeacher',
  kreaResourceTeacherTrigger: 'kreaResourceTeacherTrigger',
  kreaResourceTeacherClass: 'kreaResourceTeacherClass',
  kreaResourceTeacherValuation: 'kreaResourceTeacherValuation',
  kreaResourceStudent: 'kreaResourceStudent',
  kreaResourceStudentTrigger: 'kreaResourceStudentTrigger',
  kreaResourceStudentClass: 'kreaResourceStudentClass',
  kreaEducationalContent: 'kreaEducationalContent',
  kreaPublished: 'kreaPublished',
  kreaDrafts: 'kreaDrafts',
  kreaInRevision: 'kreaInRevision',
  kreaCreateEducationalContent: 'kreaCreateEducationalContent',
  unauthorized: 'unauthorized',
  preferences: 'preferences',
  preferencesLanguages: 'preferencesLanguages',
  team: 'team',
  corporativeLogin: 'corporativeLogin',
  login: 'login',
  googleLogin: 'googleLogin',
  googleTrial: 'googleTrial',
  searchEphemeride: 'searchEphemeride',
  seeMore: 'seeMore'
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: routes.home,
      component: () =>
        import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        isPrivate: false,
        showOverFooter: true,
        isResponsive: true,
        isLanding: true,
        pageName: 'What is kimple?'
      }
    },
    {
      path: '/content',
      name: routes.content,
      component: () =>
        import(/* webpackChunkName: "content" */ './views/Content.vue'),
      meta: {
        isPrivate: false,
        showOverFooter: true,
        isLanding: true,
        isResponsive: true,
        pageName: 'What content'
      }
    },
    {
      path: '/how-it-works',
      name: routes.howItWorks,
      component: () =>
        import(/* webpackChunkName: "how-it-works" */ './views/HowItWorksLanding.vue'),
      meta: {
        isPrivate: false,
        showOverFooter: true,
        isLanding: true,
        isResponsive: true,
        pageName: 'How it works'
      }
    },
    {
      path: '/impact',
      name: routes.impact,
      component: () =>
        import(/* webpackChunkName: "impact" */ './views/SocialImpact.vue'),
      meta: {
        isPrivate: false,
        showOverFooter: true,
        isLanding: true,
        isResponsive: true,
        pageName: 'Social Impact'
      }
    },
    {
      path: '/feed',
      name: routes.feed,
      component: () => import(/* webpackChunkName: "feed" */ './views/Feed.vue'),
      redirect: { name: routes.feedInitial },
      meta: { isPrivate: true },
      children: [
        {
          path: '/',
          name: routes.feedInitial,
          component: () => import(/* webpackChunkName: "feed-initial" */ './components/NewFeed/Feed.vue'),
          meta: { isPrivate: true, pageName: 'Feed' }
        },
        {
          path: 'search',
          name: routes.search,
          component: () => import(/* webpackChunkName: "feed-search" */ './components/NewFeed/SearchResults.vue'),
          meta: { isPrivate: true, pageName: 'Feed search result' },
          props: true
        },
        {
          path: 'search/ephemeride/:ephemerideId',
          name: routes.searchEphemeride,
          component: () => import(/* webpackChunkName: "feed-search-ephemeride" */ './components/NewFeed/Ephemeride.vue'),
          meta: { isPrivate: true }
        },
        {
          path: '/see-more',
          name: routes.seeMore,
          component: () => import(/* webpackChunkName: "feed-see-more" */ './components/NewFeed/SeeMore.vue'),
          meta: { isPrivate: true }
        }
      ]
    },
    {
      path: '/resource/:id',
      name: routes.resource,
      component: () =>
        import(/* webpackChunkName: "resource" */ './views/Resource.vue'),
      redirect: { name: routes.resourcePresentation },
      meta: { isPrivate: true },
      children: [
        {
          path: '',
          name: routes.resourcePresentation,
          component: () =>
            import(/* webpackChunkName: "resource-presentation" */ './components/Resource/PresentationTab.vue'),
          meta: { isPrivate: true, pageName: 'Resource - Presentation Tab' }
        },
        {
          path: 't',
          name: routes.teacherResource,
          component: () => import(/* webpackChunkName: "resource-teacher" */ './components/Resource/TeacherTab.vue'),
          meta: { isPrivate: true, pageName: 'Resource - Teacher Tab' },
          redirect: { name: routes.teacherResourceTrigger },
          children: [
            {
              path: '',
              name: routes.teacherResourceTrigger,
              component: () => import(/* webpackChunkName: "resource-teacher-trigger" */ './components/Resource/Trigger.vue'),
              meta: { isPrivate: true, pageName: 'Resource - Teacher Tab trigger' }
            },
            {
              path: 'valuation',
              name: routes.teacherResourceValuation,
              component: () => import(/* webpackChunkName: "resource-teacher-valuation" */ './components/Resource/Valuation.vue'),
              meta: { isPrivate: true, pageName: 'Resource - Teacher Tab valuation' }
            },
            {
              path: 'class/:classId',
              name: routes.teacherResourceClass,
              component: () => import(/* webpackChunkName: "resource-teacher-class" */ './components/Resource/Class.vue'),
              meta: { isPrivate: true, pageName: 'Resource - Teacher Tab class' }
            }
          ]
        },
        {
          path: 's',
          name: routes.studentResource,
          component: () =>
            import(/* webpackChunkName: "resource-student" */ './components/Resource/StudentTab.vue'),
          meta: { isPrivate: true, pageName: 'Resource - Student Tab' },
          redirect: { name: routes.studentResourceTrigger },
          children: [
            {
              path: '',
              name: routes.studentResourceTrigger,
              component: () => import(/* webpackChunkName: "resource-student-trigger" */ './components/Resource/Trigger.vue'),
              meta: { isPrivate: true, pageName: 'Resource - Student Tab trigger' }
            },
            {
              path: 'class/:classId',
              name: routes.studentResourceClass,
              component: () => import(/* webpackChunkName: "resource-student-class" */ './components/Resource/Class.vue'),
              meta: { isPrivate: true, pageName: 'Resource - Student Tab class' }
            }
          ]
        }
      ]
    },
    {
      path: '/r/:id',
      name: routes.studentPublicResource,
      component: () => import(/* webpackChunkName: "student-resource" */ './views/StudentPublicResource.vue'),
      meta: { isPrivate: false, allowSession: true, isResponsive: true, pageName: 'Resource - Student Link', isStudentPublicResource: true },
      children: [
        {
          path: '',
          name: routes.studentPublicResourceTrigger,
          component: () => import(/* webpackChunkName: "student-resource-trigger" */ './components/Resource/Trigger.vue'),
          meta: { isPrivate: false, allowSession: true, isResponsive: true, pageName: 'Resource - Student Link trigger', isStudentPublicResource: true }
        },
        {
          path: 'class/:classId',
          name: routes.studentPublicResourceClass,
          component: () => import(/* webpackChunkName: "student-resource-class" */ './components/Resource/Class.vue'),
          meta: { isPrivate: false, allowSession: true, isResponsive: true, pageName: 'Resource - Student Link class', isStudentPublicResource: true }
        }
      ]
    },
    {
      path: '/my-stats',
      name: routes.stats,
      component: () =>
        import(/* webpackChunkName: "stats" */ './views/Statistics.vue'),
      meta: { isPrivate: true, pageName: 'Statistics' }
    },
    {
      path: '/folders',
      name: routes.folderList,
      component: () =>
        import(/* webpackChunkName: "folders" */ './views/Folders.vue'),
      meta: { isPrivate: true, pageName: 'Folders list' },
      props: true
    },
    {
      path: '/folders/:id',
      name: routes.folderContent,
      component: () =>
        import(/* webpackChunkName: "folder-content" */ './views/FolderContent.vue'),
      meta: { isPrivate: true, pageName: 'Folder detail' }
    },
    {
      path: '/programs',
      name: routes.educationalPrograms,
      component: () =>
        import(/* webpackChunkName: "educational-programs" */ './views/EducationalPrograms.vue'),
      meta: { isPrivate: true, pageName: 'Educational Program List' }
    },
    {
      path: '/program/:id',
      name: routes.educationalProgram,
      component: () =>
        import(/* webpackChunkName: "educational-programs" */ './views/EducationalProgram.vue'),
      meta: { isPrivate: true, pageName: 'Educational Program Detail' }
    },
    {
      path: '/reset-password',
      name: routes.resetPassword,
      component: () =>
        import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
      meta: { isPrivate: false, pageName: 'Reset Password' }
    },
    {
      path: '/profile',
      name: routes.profile,
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
      redirect: { name: 'myProfile' },
      meta: { isPrivate: true },
      children: [
        {
          path: 'my-profile',
          name: routes.myProfile,
          component: () => import(/* webpackChunkName: "my-profile" */ './components/Profile/ProfileTab.vue'),
          meta: { isPrivate: true, pageName: 'Profile' }
        },
        {
          path: 'my-profile/edit',
          name: routes.myProfileEdit,
          component: () => import(/* webpackChunkName: "my-profile-edit" */ './components/Profile/EditProfileTab.vue'),
          meta: { isPrivate: true, pageName: 'Profile edition' }
        },
        {
          path: 'school',
          name: routes.school,
          component: () => import(/* webpackChunkName: "school" */ './components/Profile/SchoolTab.vue'),
          meta: { isPrivate: true, pageName: 'School' }
        },
        {
          path: 'school/edit',
          name: routes.schoolEdit,
          component: () => import(/* webpackChunkName: "school-edit" */ './components/Profile/EditSchoolTab.vue'),
          meta: { isPrivate: true, pageName: 'School edition' }
        },
        {
          path: 'school-group',
          name: routes.schoolGroup,
          component: () => import(/* webpackChunkName: "school-group" */ './components/Profile/SchoolGroupTab.vue'),
          meta: { isPrivate: true, pageName: 'School group' }
        },
        {
          path: 'school-group/edit',
          name: routes.schoolGroupEdit,
          component: () => import(/* webpackChunkName: "school-group-edit" */ './components/Profile/EditSchoolGroupTab.vue'),
          meta: { isPrivate: true, pageName: 'School group edition' }
        }
      ]
    },
    {
      path: '/profile/team/:schoolId',
      name: routes.team,
      component: () => import(/* webpackChunkName: "team" */ './views/Team.vue'),
      meta: { isPrivate: true, pageName: 'Team' }
    },
    {
      path: '/preferences',
      component: () => import(/* webpackChunkName: "preferences" */ './views/Preferences.vue'),
      meta: { isPrivate: true, pageName: 'Preferences' },
      children: [
        {
          path: '',
          name: routes.preferences,
          component: () => import(/* webpackChunkName: "preferences-options" */ './components/Preferences/Options.vue'),
          meta: { isPrivate: true, pageName: 'Preferences - Options' }
        },
        {
          path: 'languages',
          name: routes.preferencesLanguages,
          component: () => import(/* webpackChunkName: "preferences-languages" */ './components/Preferences/Languages.vue'),
          meta: { isPrivate: true, pageName: 'Preferences - Languages' }
        }
      ]
    },
    {
      path: '/trial',
      name: routes.trial,
      component: () =>
        import(/* webpackChunkName: "trial" */ './views/Trial.vue'),
      meta: { isPrivate: false, pageName: 'Trial Invitation', isResponsive: true },
      props: true
    },
    {
      path: '/register',
      name: routes.register,
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue'),
      meta: { isPrivate: false, pageName: 'Trial Registration', isResponsive: true }
    },
    {
      path: '/unauthorized',
      name: routes.unauthorized,
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue'),
      meta: { isPrivate: true, pageName: 'Unauthorized' },
      props: true
    },
    {
      path: '/not-found',
      name: routes.notFound,
      component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound.vue'),
      meta: { isPrivate: true },
      props: { feed: routes.feed, pageName: 'Page Not Found' }
    },
    {
      path: '/faqs',
      name: routes.faqs,
      component: () => import(/* webpackChunkName: "faqs" */ './views/Faqs.vue'),
      meta: { isPrivate: true, pageName: 'Faqs' }
    },
    {
      path: '/trial-finished',
      name: routes.trialFinished,
      component: () => import(/* webpackChunkName: "trial-finished" */ './views/TrialFinished.vue'),
      meta: { isPrivate: true, pageName: 'Finished trial' }
    },
    {
      path: '/quote/:license',
      name: routes.quote,
      component: () => import(/* webpackChunkName: "quote" */ './views/Quote.vue'),
      meta: { isPrivate: false, pageName: 'Quote license' }
    },
    {
      path: '/used-token',
      name: routes.usedToken,
      component: () => import(/* webpackChunkName: "used-token" */ './views/UsedToken.vue'),
      meta: { isPrivate: false, pageName: 'Invitation token already used' }
    },
    {
      path: '/expired-token',
      name: routes.expiredToken,
      component: () => import(/* webpackChunkName: "expired-token" */ './views/ExpiredToken.vue'),
      meta: { isPrivate: false, pageName: 'Invitation token expired' },
      props: true
    },
    {
      path: '/activate',
      name: routes.activate,
      component: () => import(/* webpackChunkName: "activation" */ './views/AccountActivation.vue'),
      meta: { isPrivate: false, pageName: 'Invitation activation' },
      props: true
    },
    {
      path: '/license',
      name: routes.license,
      component: () => import(/* webpackChunkName: "license" */ './views/License.vue'),
      meta: { isPrivate: true, pageName: 'Licenses details' }
    },
    {
      path: '/sign-terms',
      name: routes.signTerms,
      component: () => import(/* webpackChunkName: "sign-terms" */ './views/SignTerms.vue'),
      meta: { isPrivate: true, pageName: 'Sign terms and conditions' }
    },
    {
      path: '/krea',
      name: routes.krea,
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea' },
      beforeEnter: async (to, from, next) => {
        store.state.behavior.fullPageLoader.show = true
        const { data } = await getTermsAndConditions()
        store.state.behavior.fullPageLoader.show = false
        if (data.signedTermsAndCondition) next({ name: routes.kreaPublished })
        else next({ name: routes.signTerms })
      }
    },
    {
      path: '/krea/resource/:id',
      name: routes.kreaResource,
      component: () => import(/* webpackChunkName: "krea-resource" */ './views/KreaResource.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource' },
      redirect: { name: routes.kreaResourcePresentation },
      props: true,
      children: [
        {
          path: '',
          name: routes.kreaResourcePresentation,
          component: () => import(/* webpackChunkName: "krea-resource-presentation" */ './components/Krea/Resource/PresentationTab.vue'),
          meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Presentation Tab' },
          props: true
        },
        {
          path: 't',
          name: routes.kreaResourceTeacher,
          component: () => import(/* webpackChunkName: "resource-teacher" */ './components/Krea/Resource/TeacherTab.vue'),
          meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Teacher Tab' },
          redirect: { name: routes.kreaResourceTeacherTrigger },
          props: true,
          children: [
            {
              path: '',
              name: routes.kreaResourceTeacherTrigger,
              component: () => import(/* webpackChunkName: "krea-resource-teacher-trigger" */ './components/Krea/Resource/Trigger.vue'),
              meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Teacher Tab trigger' },
              props: true
            },
            {
              path: 'valuation',
              name: routes.kreaResourceTeacherValuation,
              component: () => import(/* webpackChunkName: "krea-resource-teacher-valuation" */ './components/Krea/Resource/Valuation.vue'),
              meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Teacher Tab valuation' },
              props: true
            },
            {
              path: 'class/:classId',
              name: routes.kreaResourceTeacherClass,
              component: () => import(/* webpackChunkName: "krea-resource-teacher-class" */ './components/Krea/Resource/Class.vue'),
              meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Teacher Tab class' },
              props: true
            }
          ]
        },
        {
          path: 's',
          name: routes.kreaResourceStudent,
          component: () => import(/* webpackChunkName: "resource-student" */ './components/Krea/Resource/StudentTab.vue'),
          meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Student Tab' },
          redirect: { name: routes.kreaResourceStudentTrigger },
          props: true,
          children: [
            {
              path: '',
              name: routes.kreaResourceStudentTrigger,
              component: () => import(/* webpackChunkName: "krea-resource-student-trigger" */ './components/Krea/Resource/Trigger.vue'),
              meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Student Tab trigger' },
              props: true
            },
            {
              path: 'class/:classId',
              name: routes.kreaResourceStudentClass,
              component: () => import(/* webpackChunkName: "krea-resource-student-class" */ './components/Krea/Resource/Class.vue'),
              meta: { isKrea: true, isPrivate: true, pageName: 'Krea resource - Student Tab class' },
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '/krea/content/:id',
      name: routes.kreaEducationalContent,
      component: () => import(/* webpackChunkName: "krea-educational-content" */ './views/KreaEducationalContent.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea new educational content' },
      props: true
    },
    {
      path: '/krea/published',
      name: routes.kreaPublished,
      component: () => import(/* webpackChunkName: "krea-published" */ './views/KreaPublished.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea published' }
    },
    {
      path: '/krea/drafts',
      name: routes.kreaDrafts,
      component: () => import(/* webpackChunkName: "krea-drafts" */ './views/KreaDrafts.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea drafts' }
    },
    {
      path: '/krea/in-revision',
      name: routes.kreaInRevision,
      component: () => import(/* webpackChunkName: "krea-in-revision" */ './views/KreaInRevision.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea in revision' }
    },
    {
      path: '/krea/create-content',
      name: routes.kreaCreateEducationalContent,
      component: () => import(/* webpackChunkName: "krea-create-educational-content" */ './views/KreaCreateEducationalContent.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea create educational content' }
    },
    {
      path: '/krea/my-resources',
      name: routes.kreaMyResources,
      component: () => import(/* webpackChunkName: "krea-resources" */ './views/KreaResources.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea my resources' }
    },
    {
      path: '/krea/schools-group-resources',
      name: routes.kreaSchoolsGroupResources,
      component: () => import(/* webpackChunkName: "krea-resources" */ './views/KreaResources.vue'),
      meta: { isKrea: true, isPrivate: true, pageName: 'Krea schools group resources' }
    },
    {
      path: '/kimple-folders/:id',
      name: routes.kimpleFolderContent,
      component: () => import(/* webpackChunkName: "kimple-folder-content" */ './views/KimpleFolderContent.vue'),
      meta: { isPrivate: true, pageName: 'Kimple Folder detail' }
    },
    {
      path: '/corporative-login',
      name: routes.corporativeLogin,
      component: () => import(/* webpackChunkName: "corporative-login" */ './views/CorporativeLogin.vue'),
      meta: { isPrivate: false, isResponsive: true, hideNavbar: true, pageName: 'Corporative log in' }
    },
    {
      path: '/login',
      name: routes.login,
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: { isPrivate: false, isResponsive: true, pageName: 'Log in' }
    }
  ],
  scrollBehavior () {
    return { y: 0 }
  }
})
